import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { resetAction } from '../actions/resetAction';
import { CustomActivitiesState } from '../storeTypes';
import { ConfigCatalogDto, CustomActivityDto } from '../../types/customActivity';

const initialState: CustomActivitiesState = {
  customActivities: {},
};

const customActivitiesSlice = createSlice({
  name: 'customActivitiesSlice',
  initialState,
  extraReducers: (builder) => builder.addCase(resetAction, () => initialState),
  reducers: {
    setCustomActivitiesAction: (
      draftState: CustomActivitiesState,
      action: PayloadAction<{ customActivities: CustomActivityDto[] }>,
    ) => {
      draftState.customActivities = {};
      action.payload.customActivities.forEach((ca) => {
        draftState.customActivities[ca.id] = ca;
      });
    },
    upsertCustomActivityAction: (
      draftState: CustomActivitiesState,
      action: PayloadAction<{ customActivity: CustomActivityDto }>,
    ) => {
      const ca = action.payload.customActivity;
      draftState.customActivities[ca.id] = ca;
    },
    removeCustomActivityFromStoreAction: (
      draftState: CustomActivitiesState,
      action: PayloadAction<{ id: string }>,
    ) => {
      delete draftState.customActivities[action.payload.id];
    },
    setConfigCatalogAction: (
      draftState: CustomActivitiesState,
      action: PayloadAction<{ configCatalog: ConfigCatalogDto }>,
    ) => {
      draftState.configCatalog = action.payload.configCatalog;
    },
  },
});

export const {
  setCustomActivitiesAction,
  upsertCustomActivityAction,
  removeCustomActivityFromStoreAction,
  setConfigCatalogAction,
} = customActivitiesSlice.actions;

export default customActivitiesSlice;
